import { render, staticRenderFns } from "./remoteDiagnosis.vue?vue&type=template&id=eeed33aa&scoped=true&"
import script from "./remoteDiagnosis.vue?vue&type=script&lang=js&"
export * from "./remoteDiagnosis.vue?vue&type=script&lang=js&"
import style0 from "./remoteDiagnosis.vue?vue&type=style&index=0&id=eeed33aa&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eeed33aa",
  null
  
)

export default component.exports